// This file is autogenerated. Any changes will be overwritten.

export const set = 'streamline';

export const name = 'motherboard';

export const Component = () => (
  <g fill='none' stroke='currentColor' strokeLinecap='round' strokeLinejoin='round'>
    <path d='M13.781 1.031v1.063h-3.187V1.03H3.156a2.125 2.125 0 0 0-2.125 2.125v7.969h1.063v2.125H1.03v1.594a2.125 2.125 0 0 0 2.125 2.125h11.688a2.125 2.125 0 0 0 2.125-2.125V3.156a2.125 2.125 0 0 0-2.125-2.125zm0 10.094h1.594M13.781 9h1.594m-9.562 2.125h1.593M5.813 9h1.593m4.25 4.25v1.594M9.531 13.25v1.594m2.125-9.563v1.594M9.531 5.281v1.594' />
    <path d='M7.406 6.875h6.375v6.375H7.406zm-4.25-3.719v2.125m2.125-2.125v2.125' />
  </g>
);

export const viewBox = '0 0 18 18';
